import { css } from '@emotion/css';

export const uploadClass = css`
  display: inline-flex;
  .ant-upload {
    display: inline-flex;
  }
`;
